import instance from "../axios";

export const getSelfOrderTheme = async (partnerId) => {
  const response = await instance.get(
    "theme/Get.php?partner_id=" + partnerId
  );

  return response.data;
};

